import { ca } from '@cian/analytics';

export function track3DTourBlockClick() {
  ca('eventSite', {
    action: 'Click',
    category: 'card',
    label: '3dtour_viewer',
    name: 'oldevent',
    useLastProducts: true,
  });
}
